import Immutable, { Immutable as ImmutableGenericType } from 'seamless-immutable'

export enum NotificationSeverityEnum {
  Normal,
  Warning,
  Error,
}

export interface NotificationMessage {
  title?: any
  content?: any
  severity: NotificationSeverityEnum
}

export interface NotificationState {
  [x: string]: NotificationMessage
}

// @ts-ignore
export const initialState: ImmutableGenericType<NotificationState> = Immutable({})
